export var BlackListType;
(function (BlackListType) {
    BlackListType["PAYMENT"] = "PAYMENT";
    BlackListType["RETURN"] = "RETURN";
    BlackListType["ACCIDENT"] = "ACCIDENT";
})(BlackListType || (BlackListType = {}));
